/**
 * Maps a Ready2Resource (RR) educator type title to the shortened label that
 * Ready2Book displays in the educator details modal.
 *
 * The mapping is sourced from the "Educator Type Filters" reference attached to
 * ADO story 4327. Keys are matched on the trimmed RR type title; any type not
 * present in the table falls back to its original (trimmed) title so new RR
 * types degrade gracefully rather than disappearing from the UI.
 *
 * @type {Readonly<Record<string, string>>}
 */
export default Object.freeze({
  Primary: 'Primary',
  Secondary: 'Secondary',
  'Early Childhood': 'Early Childhood',
  SEN: 'SEN',
  P12: 'P12',
  'Adult Education': 'Adult Ed',
  OSHC: 'OSHC',
  TA: 'TA',
  Administration: 'Admin',
  Government: 'Government',
  Independent: 'Independent',
  Council: 'Council',
  Kindergarten: 'Kinder',
  PRU: 'PRU',
  'K-12': 'K-12',
  'Middle School': 'Middle School',
  Intermediate: 'Intermediate',
  ECE: 'Early Childhood',
  'NZ - Primary Teacher': 'Primary',
  'NZ - ECE Fundable': 'ECE Fundable',
  'NZ - Secondary Teacher': 'Secondary',
  'NZ - Support Staff': 'Support',
  'Teacher - Tutor': 'Teacher - Tutor',
  'UK - Cover Supervisor': 'Cover Supervisor',
  'US - High School': 'High School',
  'US - Elementary': 'Elementary',
  'US - K-8': 'K-8',
  'US - 6-12': '6-12',
  'US - Early Year': 'Early Year',
  'US - Adult Ed': 'Adult Ed',
  'UK - Instructor': 'Instructor',
  'Support Worker': 'Support',
  'Qualified Nurse': 'Nurse',
  'Care Team': 'Care Team',
  'Adult Assessment': 'Adult Assessment',
  'Adult Computer Training': 'Adult Ed - Computing',
  'Adult Literacy': 'Adult Ed - Literacy',
  'Adult Numeracy': 'Adult Ed - Numeracy',
  'After School Care': 'After School',
  AIDE: 'AIDE',
  'Bilingual and Immersion': 'Bilingual & Immersion',
  Cook: 'Cook',
  ESOL: 'ESOL',
  'Holiday Programme': 'Holiday Programme',
  Nanny: 'Nanny',
  Other: 'Other',
  'Special Education': 'Special Ed',
  'Tertiary/Adult': 'Tertiary/Adult',
  'Cover Supervisor': 'Cover Supervisor',
  'NZ - ECE Qual. & Regd.': 'ECE Qualified',
  'TA - Tutor': 'TA - Tutor',
  'US - Middle School': 'Middle School',
  'US - K-12': 'K-12',
  'Holiday Program or OSCAR': 'Holiday Programme',
})
